import {
  MapPaymentItem as EpayPaymentItem
} from '../../epayment/models/payment_item';

export { PaymentItem } from '../../epayment/models/payment_item';


export const MapPaymentItem = EpayPaymentItem.extend({
  url: '/parentpay/accounts/'
});



// WEBPACK FOOTER //
// ./parentpay/models/payment_item.js